module.exports = __webpack_public_path__ + "img/19.ab270a26.png";